import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
    
  })
};

@Injectable({
  providedIn: 'root'
})

export class QuestionService {

  constructor(
    private http: HttpClient
  ) {}

  getQuestion(topic,sort,type,paper) {
    if (type == 'year'){
      return this.http.get('https://api.studybio.net/api/get_mc_question.php?paperid='+topic+'&sort='+sort+'&paper='+paper+'&type=year&limit=150',{withCredentials: true});
    } else {
      return this.http.get('https://api.studybio.net/api/get_mc_question.php?topic='+topic+'&sort='+sort+'&paper='+paper+'&type=topic&limit=150',{withCredentials: true});
    }  
  }

  getSQByTopic(type, topic,paper){
    return this.http.get('https://api.studybio.net/api/get_p1_question.php?topic='+topic+'&type='+type+'&paper='+paper,{withCredentials: true});
  }

  submitMC (data,score,fullmark,tag,type,time) {
    var xhr = new XMLHttpRequest();
    var url = "https://api.studybio.net/api/submit_mc.php";
    xhr.open("POST", url, true);
    xhr.withCredentials = true;
    xhr.setRequestHeader("Content-Type", 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            console.log(xhr.responseText);         
        }
    };

    console.log(data);
    xhr.send('data=' +data+'&score=' +score+'&fullmark=' +fullmark+'&tag=' +tag+'&type=' +type+'&time=' +time);
  }
}
